
// export const myGetter = ( client ) => {
//  return client
// }

export const clientsList = state => state.clients
export const clientsSelectable = state => state.clientsSelectable
export const clientsPaginatedData = state => state.clientsPaginatedData
export const client = state => state.client
export const clientSelect = state => state.clientSelect
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData
export const isLoadingClientProducts = state => state.isLoadingClientProducts
export const clientProducts = state => state.clientProducts


export const clientInputsLength = state => state.clientInputsLength
export const clientOutputsLength = state => state.clientOutputsLength
